/*
 * The welcome on a small sky: the onboarding's last step and a newcomer's first #general (ADR 0090). The sky is the
 * same blue in both themes, so its ink is the deep sky ink; buttons on it are the sky's glass.
 */
.welcome-card {
  position: relative;
  min-height: 220px;
  padding: 24px;
  border-radius: 24px;
  overflow: hidden;
  background: #2b74e6;
  color: var(--sky-ink);
  isolation: isolate;
}
/* In a channel, under its header like the day's greeting. */
.welcome-card--channel {
  flex: none;
  min-height: 0;
  margin: 12px 16px 0;
  border-radius: 20px;
}
.welcome-card__text {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: fit-content;
  max-width: 52ch;
}
.welcome-card:has(> .welcome-card__close) .welcome-card__text {
  padding-right: 40px;
}
.welcome-card__title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: var(--font-display-weight, 300);
  font-size: 30px;
  line-height: 1.1;
  letter-spacing: -0.02em;
}
.welcome-card__lead {
  margin: 0;
  color: var(--sky-ink2);
  font-weight: 500;
}
.welcome-card__crew {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}
/* A face with its first name under it (who works there, for a newcomer). */
.welcome-card__who {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
}
.welcome-card__acts {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
}
.welcome-card__acts > .ac-btn,
.welcome-card__close.ac-btn {
  background: var(--sky-glass);
  color: var(--sky-ink);
  box-shadow: 0 0 0 1px var(--sky-line);
}
.welcome-card__acts > .ac-btn:hover,
.welcome-card__close.ac-btn:hover {
  background: rgba(255, 255, 255, 0.86);
}
html:not([data-pointer]) .welcome-card__acts > .ac-btn:focus-visible,
html:not([data-pointer]) .welcome-card__close.ac-btn:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 2px #fff,
    0 0 0 4px var(--sky-ink);
}
.welcome-card__acts > .ac-btn .ac-avatar {
  flex: none;
}
.welcome-card__close {
  position: absolute;
  top: 12px;
  right: 12px;
}
@media (max-width: 760px) {
  .welcome-card__crew {
    gap: 8px;
  }
  .welcome-card__crew .ac-avatar--lg {
    width: 48px;
    height: 48px;
  }
}
